
import axios from "../api/index"
export const login = async (username: string, password: string) => {
  const response = await axios.get("/user/login", { params: { username, password } })
  localStorage.setItem("currentUser", JSON.stringify(response.data))
  
  axios.defaults.headers.common["sessionToken"] = response.data.sessionToken
  return response
}